/**
 * Helpers for vLLM --default-chat-template-kwargs (stored as
 * vllm_config.default_chat_template_kwargs JSON object).
 */

export interface TemplateKwargsRow {
  key: string;
  value: string;
}

export function parseTemplateKwargValue(raw: string): unknown {
  const s = raw.trim();
  if (s === "") return "";
  try {
    return JSON.parse(s) as unknown;
  } catch {
    return raw;
  }
}

export function templateKwargsObjectFromRows(
  rows: TemplateKwargsRow[]
): Record<string, unknown> | undefined {
  const out: Record<string, unknown> = {};
  for (const row of rows) {
    const k = row.key.trim();
    if (!k) continue;
    out[k] = parseTemplateKwargValue(row.value);
  }
  return Object.keys(out).length ? out : undefined;
}

export function templateKwargsRowsFromObject(obj: unknown): TemplateKwargsRow[] {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return [];
  const o = obj as Record<string, unknown>;
  return Object.entries(o).map(([key, val]) => ({
    key,
    value:
      val === null || val === undefined
        ? ""
        : typeof val === "string"
          ? val
          : JSON.stringify(val),
  }));
}
